import {
  localDateFormatted,
  localDateTimeFormatted,
  localTimeFormatted,
} from '@/utils/helpers';
import { getValueOrNA } from '@/ui/components';
import { TFunc } from '@/translations';
import { Inspection } from '@/types';

type FieldRenderers = {
  [key: string]: (data: Inspection, t: TFunc) => React.ReactNode;
};

export const fieldRenderers: FieldRenderers = {
  inspectionDateTime: (data) =>
    data.inspectionDateTime
      ? localDateTimeFormatted(data.inspectionDateTime)
      : getValueOrNA('inspectionDate')({ data }),
  inspectionDate: (data) =>
    data.inspectionDateTime
      ? localDateFormatted(data.inspectionDateTime)
      : getValueOrNA('inspectionDate')({ data }),
  inspectionTime: (data) =>
    data.inspectionDateTime
      ? localTimeFormatted(data.inspectionDateTime)
      : getValueOrNA('inspectionDate')({ data }),
  inspectionStatus: (data) =>
    data.inspectionStatusName
      ? data.inspectionStatusName
      : getValueOrNA('inspectionStatus')({ data }),
  approvalDateTime: (data) =>
    data.approvalDateTime
      ? localDateTimeFormatted(data.approvalDateTime)
      : getValueOrNA('approvalDateTime')({ data }),
  mileage: (data) => (data.mileage ? `${data.mileage} Miles` : null),
};
